import isPostalCode from 'validator/lib/isPostalCode';
import { textValidator } from './textValidator';

export function postalCodeValidator(options?: {
  required?: boolean | string;
  trim?: boolean;
  msg?: string;
}) {
  return textValidator({
    required: options?.required,
    trim: options?.trim,
    valid: s =>
      isPostalCode(s, 'any')
        ? { type: 'valid' }
        : {
            type: 'invalid',
            msg: options?.msg ?? 'Invalid postal code format',
          },
  });
}
